import { render } from "./AppVersionManage.vue?vue&type=template&id=2d9b0ab9"
import script from "./AppVersionManage.vue?vue&type=script&lang=js"
export * from "./AppVersionManage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__